import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, map, tap } from 'rxjs';
import { ApiService } from '../api/api.service';
import { HttpMethods } from '../api/api.enums';
import { environment } from 'src/environments/environment';
import { DeliveryLocation } from '../api/contracts/location';

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  private readonly _locations = new ReplaySubject<DeliveryLocation[]>(1);
  public readonly locations: Observable<DeliveryLocation[]>;

  constructor(private readonly apiService: ApiService) {
    this.locations = this._locations.asObservable();
  }

  retrieveLocations(): Observable<DeliveryLocation[]> {
    return this.apiService
      .request<DeliveryLocation[]>({
        method: HttpMethods.GET,
        url: `${environment.apiUrl}/locations`,
      })
      .pipe(
        map((res) => res.body as DeliveryLocation[]),
        tap((res) => this._locations.next(res))
      );
  }

  retrieveLocationByHash(hash: string): Observable<DeliveryLocation> {
    return this.apiService
      .request<DeliveryLocation>({
        method: HttpMethods.GET,
        url: `${environment.apiUrl}/locations/${hash}`,
      })
      .pipe(map((res) => res.body as DeliveryLocation));
  }
}
